import cleanedFilename from '~/util/cleanedFilename';

export default {
  CHEVRON: `${cleanedFilename(__filename)}-chevron`,
  BUTTON: `${cleanedFilename(__filename)}-button`,
};
